// removed by extract-text-webpack-plugin
module.exports = {"content":"CustomFormCreate__content__3YSoX","parentContainer":"CustomFormCreate__parentContainer__3wK6L","nameCustomFormWrapper":"CustomFormCreate__nameCustomFormWrapper__2PMq-","table":"CustomFormCreate__table__2esVH","wrapper":"CustomFormCreate__wrapper__1WdFM","errorWrapper":"CustomFormCreate__errorWrapper__31eyl","actionWrapper":"CustomFormCreate__actionWrapper__dEUBZ","alertResult":"CustomFormCreate__alertResult__TEcl3"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/CustomFormCreate/CustomFormCreate.css
// module id = 3084
// module chunks = 0